import React from "react";
import { Link } from "react-router-dom";
import {
  Container,
  Grid,
  Card,
  Title,
  Text,
  Button,
  Group,
  Center,
} from "@mantine/core";
import useCurrentUserQuery from "../hooks/queries/useAuthQueries";
import useAuthStore from "../stores/authStore";

export default function Unauthorized() {
  useCurrentUserQuery();

  const store = useAuthStore();
  const { computedUser } = store;
  const tokenUser = store.user;
  const user = computedUser || tokenUser;

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "var(--mantine-color-gray-0)",
      }}
    >
      <Container fluid px="md">
        <Center style={{ minHeight: "80vh" }}>
          <Card
            shadow="md"
            radius="lg"
            withBorder
            style={{
              width: "100%",
              maxWidth: 900,
              overflow: "hidden",
            }}
          >
            <Grid>
              {/* LEFT VISUAL PANEL */}
              <Grid.Col
                md={5}
                sm={12}
                style={{
                  background:
                    "linear-gradient(135deg, #2563EB 0%, #1E3A8A 100%)",
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "3rem 1.5rem",
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <div
                    style={{
                      background: "rgba(255,255,255,0.1)",
                      borderRadius: "50%",
                      width: 80,
                      height: 80,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 1rem",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      width="48"
                      height="48"
                      strokeWidth="1.5"
                    >
                      <rect x="3" y="11" width="18" height="10" rx="2" ry="2" />
                      <path d="M7 11V7a5 5 0 0110 0v4" />
                    </svg>
                  </div>

                  <Title order={2} fw={600} mb={8}>
                    Access Denied
                  </Title>
                  <Text
                    size="sm"
                    c="rgba(255,255,255,0.85)"
                    maw={260}
                    mx="auto"
                  >
                    You don’t have permission to view this page. Please contact
                    your administrator if you believe this is an error.
                  </Text>
                </div>
              </Grid.Col>

              {/* RIGHT CONTENT PANEL */}
              <Grid.Col
                md={7}
                sm={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "2.5rem",
                }}
              >
                <div style={{ width: "100%" }}>
                  <Title order={3} mb={10}>
                    You’re not authorized
                  </Title>
                  <Text color="dimmed" mb={24}>
                    The account you’re using doesn’t have the necessary
                    permissions to access this section. You can return to your
                    dashboard or request access below.
                  </Text>

                  <Group direction="column" spacing="sm" grow>
                    {user && user?.roles?.length > 0 && (
                      <Button component={Link} to="/dashboard">
                        Go to Dashboard
                      </Button>
                    )}

                    <Button
                      component="a"
                      href="mailto:support@paykit.africa?subject=Access%20Request"
                      variant="outline"
                    >
                      Request Access
                    </Button>
                  </Group>

                  <Text size="xs" color="dimmed" mt={20}>
                    Tip: If your role recently changed, try refreshing or
                    signing in again.
                  </Text>
                </div>
              </Grid.Col>
            </Grid>
          </Card>
        </Center>
      </Container>
    </div>
  );
}
